import { useTranslation } from 'react-i18next';
import { Button, ButtonProps } from '@sib/ui';
import { useDialog } from '../../hooks';
import { ShareDialog } from './ShareDialog';

interface ShareButtonProps extends ButtonProps {
  className?: string;
}

export const ShareButton = ({ onClick, ...props }: ShareButtonProps) => {
  const { t } = useTranslation();
  const { handleOpen, handleClose, isOpen } = useDialog();

  return (
    <>
      <ShareDialog onClose={handleClose} open={isOpen} />
      <Button
        onClick={e => {
          handleOpen();
          onClick?.(e);
        }}
        {...props}
      >
        {t('share')}
      </Button>
    </>
  );
};
